import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { NgForm, NgModel } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { Row } from '@sdbn/appclient';
import { ColumnType } from '@sdbn/appclient';
import { SelectionType } from '@sdbn/appclient';
import { TmcTableModel } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { TransportWeighing } from './../model/transport-weighing';
import { WeighTransportService } from './../service/weigh-transport.service';
import { TranslationService } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/appclient';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { WeighingType } from '../model/weighing-type.enum';
import { DatePipe } from '@angular/common';
import { ConfigurationService } from '@sdbn/appclient';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { AutoWeighingService } from 'src/tmc-yard/legacy/auto-weighing/auto-weighing.service';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';

export interface WeighTransportDialogData {
  transportId: number;
  carrier: string;
  identifier: string;
  name: string;
  transportScope: string;
  successCallback: () => void;
}

@Component({
  selector: 'app-weigh-transport-dialog',
  templateUrl: './weigh-transport-dialog.component.html',
  styleUrls: ['./weigh-transport-dialog.component.scss']
})
export class WeighTransportDialogComponent implements OnInit {


  @ViewChild('inputForm', { static: true }) inputForm: NgForm;

  responseMessages: ResponseMessage[];

  private datePipe = new DatePipe('de');

  date;
  time;
  value;
  autoWeight: number;
  type: WeighingType;
  typeOptions: WeighingType[] = [];
  sourceOptions: string[] = [];
  source: string;

  weighings: TransportWeighing[] = [];

  tableModel: TmcTableModel = new TmcTableModel();

  clientParameters = TMCClientParameters;

  constructor(
    public dialogRef: MatDialogRef<WeighTransportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WeighTransportDialogData,
    public cps: ConfigurationService,
    private contextService: TmcContextService,
    public translationService: TranslationService,
    private weighTransportService: WeighTransportService,
    private dialog: MatDialog,
    private autoWeighingService: AutoWeighingService) {

    for (const t of Object.keys(WeighingType)) {
      this.typeOptions.push(WeighingType[t]);
    }

    this.date = this.datePipe.transform(new Date(), 'yyyy-MM-dd', this.contextService.getYard().timezone);
    this.time = this.datePipe.transform(new Date(), 'HH:mm', this.contextService.getYard().timezone);

    this.tableModel.selectionType = SelectionType.NONE;
    this.tableModel.sortable = false;
    this.tableModel.filterable = false;

    const prefix = 'tmc.weigh-transport-dialog.weighings.table.column.';
    this.tableModel.columnDefinitions = [
      { id: 'date', name: 'date', visible: true, type: ColumnType.STRING, translationKey: prefix + 'date' },
      { id: 'type', name: 'type', visible: true, type: ColumnType.DICTIONARY, translationKey: prefix + 'type' },
      { id: 'value', name: 'value', visible: true, type: ColumnType.STRING, translationKey: prefix + 'value' },
      { id: 'source', name: 'source', visible: true, type: ColumnType.DICTIONARY, translationKey: prefix + 'source' }
    ];
  }

  private convertToTableRows(weighings: TransportWeighing[]): Row[] {
    const rows: Row[] = [];
    for (const w of weighings) {
      const row: Row = new Row();
      row.id = w.id + '';
      row.values = {
        id: w.id, date: w.date
      };
      row.values.value = w.value;
      row.values.type = 'tmc.weigh-transport-dialog.weighingType.' + w.type;
      row.values.source = 'tmc.weighing.auto.sources.label.' + w.source;

      row.sortValues = { date: w.dateSortValue };

      rows.push(row);
    }
    return rows;
  }

  ngOnInit() {
    this.loadWeighings();
    const sourcesValue = this.cps.getClientParamValue('ui-component.transport-details.weighing.auto.sources', null);
    if (sourcesValue != null && sourcesValue.length > 0) {
      this.sourceOptions = sourcesValue.split('|');
      if (this.sourceOptions != null && this.sourceOptions.length > 0) {
        this.source = this.sourceOptions[0];
      }
    } else {
      this.sourceOptions = [];
    }
  }

  isCloseDialogDisabled() {
    return false;
  }

  isConfirmDisabled() {
    return false;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  addWeighing() {

    this.responseMessages = [];

    if (this.inputForm.form.valid) {

      if ((this.type === WeighingType.EMPTY || this.type === WeighingType.FULL) && this.fullOrEmptyExists()) {
        const dialogData: ConfirmDialogData = {
          titleKey: 'tmc.weigh-transport-dialog.confirm.override.titleKey',
          messageKey: 'tmc.weigh-transport-dialog.confirm.override.messageKey',
          confirm: () => {
            this.performAddWeighing();
          }
        };
        this.dialog.open(ConfirmDialogComponent, {
          data: dialogData
        });
      } else {
        this.performAddWeighing();
      }
    }
  }

  private performAddWeighing() {
    const tw = new TransportWeighing();
    tw.date = this.datePipe.transform(this.date + ' ' + this.time, 'dd.MM.yyyy HH:mm', this.contextService.getYard().timezone);
    tw.transportId = this.data.transportId;
    tw.type = this.type;
    tw.value = this.value;
    tw.autoWeight = this.autoWeight;
    tw.source = this.source;

    this.weighTransportService.createWeighing(tw).subscribe(
      response => {
        if (response.status === ResponseStatus.SUCCESS) {
          let sourceOption: string;
          if (this.sourceOptions != null && this.sourceOptions.length > 0) {
            sourceOption = this.sourceOptions[0];
          }
          this.inputForm.resetForm({
            value: null,
            type: null,
            date: this.datePipe.transform(new Date(), 'yyyy-MM-dd', this.contextService.getYard().timezone),
            time: this.datePipe.transform(new Date(), 'HH:mm', this.contextService.getYard().timezone),
            source: sourceOption
          });
          this.loadWeighings();
        }
        this.responseMessages = response.responseMessages;
      }, error => {
        console.error(error);
      }
    );
  }

  private fullOrEmptyExists(): boolean {
    return this.weighings.filter(w => w.type === this.type).length >= 1;
  }

  isAddWeighingDisabled() {
    return false;
  }

  private loadWeighings() {
    this.weighTransportService.getTransportWeighings({ id: this.data.transportId }).subscribe(
      result => {
        this.weighings = result;
        this.tableModel.setRows(this.convertToTableRows(result));
      }, error => {
        console.error(error);
      }
    );
  }

  showValuePositiveIntegerError(ctrl: NgModel) {
    return ctrl.touched && ctrl.hasError('positiveInteger');
  }

  createPrintout() {
    this.weighTransportService.createPrintout({ id: this.data.transportId });
  }

  public readWeight() {
    if (this.source != null) {
      console.log(this.source);
      this.autoWeighingService.readWeight(this.source).subscribe(result => {
        console.log(result);
        this.autoWeight = result.weight;
        this.value = this.autoWeight;
      });

    }
  }

  public isAutoWeighingVisible(): boolean {
    return this.sourceOptions.length > 0;
  }

  
  maxWeightExceeded() {
    return this.value > this.cps.getClientParamValue('ui-component.transport-details.weighing.max-weight', 50000);
  }
}
